<template>
  <div class="chart-selector">
    <div
      class="chart-selector-btn"
      :class="{'chart-selector-btn--active': selectedChartType === 'table'}"
      @click="selectChartType('table')"
    >
      <i class="fa fa-table p-0" />
    </div>
    <div
      class="chart-selector-btn"
      :class="{'chart-selector-btn--active': selectedChartType === 'column'}"
      @click="selectChartType('column')"
    >
      <i class="fa fa-bar-chart p-0" />
    </div>
    <div
      class="chart-selector-btn"
      :class="{'chart-selector-btn--active': selectedChartType === 'pie'}"
      @click="selectChartType('pie')"
    >
      <i class="fa fa-pie-chart p-0" />
    </div>
  </div>
</template>

<script>
import sharedMessages from '@/core/locales';
import messages from '../locales';

export default {
  name: 'ChartSelector',
  props: {
    selectedChartType: {
      type: String,
      default: 'table'
    },
  },
  methods: {
    selectChartType(type) {
      if(this.selectedChartType !== type) {
        this.$emit('onChartTypeChange', type);
      }
    }
  },
  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>

<style lang="scss" scoped>
.chart-selector {
  display: inline-flex;
  height: 100%;
}

.chart-selector-btn {
  padding: 8px 15px;
  border-left: 1px solid $reporting-settings-v2-grid-header-buttons-border-color;
  cursor: pointer;
  width: 45px;
  color: var(--component-chart-selector-btn-font-color);

  &:hover {
    color: var(--contrast);
  }
}

.chart-selector-btn--active {
  color: var(--contrast);
}
</style>